import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
  standalone: true
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, data: object): string {
    if (!data) return value;
    const keys = Object.getOwnPropertyNames(data);

    const actualkeys = keys.filter((t) => value?.indexOf(`$${t}`));
    if (actualkeys.length) {
      actualkeys.forEach((element) => {
        value = value.replace(`$${element}`, data[element]);
      });
    }
    return value;
  }
}
